// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-dropdown-button {
  width: 100%;
  border: 1px solid var(--rs-border-primary);
  background-color: var(--primary-color-light-500);
  color: var(--primary-color-600);
  border-radius: 6px;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
  gap: 10px;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}
.ui-dropdown-button[data-tooltip]:not([data-tooltip=""]) {
  --tooltip-bg-color: #000;
  --tooltip-text-color: #fff;
}
.ui-dropdown-button[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  min-width: 100%;
  background-color: var(--tooltip-bg-color);
  color: var(--tooltip-text-color);
  text-align: center;
  font-family: var(--primary-font);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  max-height: 0;
  opacity: 0.9;
  z-index: 15;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
.ui-dropdown-button[data-tooltip]:not([data-tooltip=""]):before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  z-index: 16;
}
.ui-dropdown-button[data-tooltip]:not([data-tooltip=""]):hover:not(.active):after, .ui-dropdown-button[data-tooltip]:not([data-tooltip=""]):hover:not(.active):before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}
@media screen and (max-width: 992px) {
  .ui-dropdown-button {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px;
    min-height: 40px;
    padding: 0 !important;
    gap: 0;
    border-radius: 50% !important;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 576px) {
  .ui-dropdown-button {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px;
    min-height: 36px;
  }
}
.ui-dropdown-button.active {
  border: 1px solid var(--rs-input-focus-border);
  outline: 3px solid var(--rs-color-focus-ring);
}
.ui-dropdown-button.active .ui-dropdown-button__content__icon {
  transition: 0.3s;
  transform: rotate(0deg);
}
.ui-dropdown-button:hover {
  border: 1px solid var(--rs-input-focus-border);
}
.ui-dropdown-button__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
@media screen and (max-width: 992px) {
  .ui-dropdown-button__icon {
    width: 20px;
    height: 20px;
  }
}
@media screen and (max-width: 576px) {
  .ui-dropdown-button__icon {
    width: 18px;
    height: 18px;
  }
}
.ui-dropdown-button__icon svg {
  width: 100%;
  height: 100%;
}
.ui-dropdown-button__content {
  font-family: var(--tertiary-font);
  font-weight: 500;
  flex-grow: 1;
  font-size: 1rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.5;
  display: grid;
  justify-content: space-between;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  grid-gap: 0;
  gap: 0;
  grid-row-gap: 0;
  row-gap: 0;
  width: 100%;
}
@media screen and (max-width: 992px) {
  .ui-dropdown-button__content {
    display: none !important;
  }
}
@media screen and (max-width: 576px) {
  .ui-dropdown-button__content {
    font-size: 0.875rem;
  }
}
.ui-dropdown-button__content__icon {
  transition: 0.3s;
  transform: rotate(-180deg);
}
.ui-dropdown-button__content::before, .ui-dropdown-button__content::after {
  display: none;
}
.ui-dropdown-button__content__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/DropdownButton/DropDownButton.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,0CAAA;EACA,gDAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;EACA,SAAA;EAEA,0CAAA;EACA,kBAAA;AAAF;AAGE;EACE,wBAAA;EACA,0BAAA;AADJ;AAGI;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yEAAA;EACA,eAAA;EACA,yCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAFN;AAKI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yEAAA;EACA,WAAA;AAHN;AAOM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AALR;AAUE;EA1EF;IA2EI,sBAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,MAAA;IACA,6BAAA;IACA,uBAAA;IACA,mBAAA;EAPF;AACF;AASE;EAtFF;IAuFI,sBAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;EANF;AACF;AAQE;EACE,8CAAA;EACA,6CAAA;AANJ;AAQM;EACE,gBAAA;EACA,uBAAA;AANR;AAWE;EACE,8CAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAVJ;AAYI;EAPF;IAQI,WAAA;IACA,YAAA;EATJ;AACF;AAWI;EAZF;IAaI,WAAA;IACA,YAAA;EARJ;AACF;AAUI;EACE,WAAA;EACA,YAAA;AARN;AAYE;EACE,iCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EAAA,MAAA;EACA,eAAA;EAAA,UAAA;EACA,WAAA;AAVJ;AAaI;EAlBF;IAmBI,wBAAA;EAVJ;AACF;AAYI;EAtBF;IAuBI,mBAAA;EATJ;AACF;AAWI;EACE,gBAAA;EACA,0BAAA;AATN;AAYI;EACE,aAAA;AAVN;AAaI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAXN","sourcesContent":[".ui-dropdown-button {\n  width: 100%;\n  border: 1px solid var(--rs-border-primary);\n  background-color: var(--primary-color-light-500);\n  color: var(--primary-color-600);\n  border-radius: 6px;\n  padding: 7px 12px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  gap: 10px;\n  $dropdown-button: &;\n  box-shadow: 2px 3px 4px rgba(0,0,0, 0.1);\n  position: relative;\n\n  // Tooltip styles - matching History button exactly\n  &[data-tooltip]:not([data-tooltip=\"\"]) {\n    --tooltip-bg-color: #000;\n    --tooltip-text-color: #fff;\n\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      \n      border-style: solid;\n      border-color: transparent transparent var(--tooltip-bg-color) transparent;\n      min-width: 100%;\n      background-color: var(--tooltip-bg-color);\n      color: var(--tooltip-text-color);\n      text-align: center;\n      font-family: var(--primary-font);\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.4;\n      padding: 6px 8px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      left: 50%;\n      transform: translateX(-50%);\n      max-height: 0;\n      opacity: .9;\n      z-index: 15;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent var(--tooltip-bg-color) transparent;\n      z-index: 16;\n    }\n\n    &:hover:not(.active) {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n\n  @media screen and (max-width: 992px) {\n    width: 40px !important;\n    height: 40px !important;\n    min-width: 40px;\n    min-height: 40px;\n    padding: 0 !important;\n    gap: 0;\n    border-radius: 50% !important;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media screen and (max-width: 576px) {\n    width: 36px !important;\n    height: 36px !important;\n    min-width: 36px;\n    min-height: 36px;\n  }\n\n  &.active {\n    border: 1px solid var(--rs-input-focus-border);\n    outline: 3px solid var(--rs-color-focus-ring);\n    #{$dropdown-button}__content {\n      &__icon {\n        transition: .3s;\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  &:hover {\n    border: 1px solid var(--rs-input-focus-border);\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n\n    @media screen and (max-width: 992px) {\n      width: 20px;\n      height: 20px;\n    }\n\n    @media screen and (max-width: 576px) {\n      width: 18px;\n      height: 18px;\n    }\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__content {\n    font-family: var(--tertiary-font);\n    font-weight: 500;\n    flex-grow: 1;\n    font-size: 1rem;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.5;\n    display: grid;\n    justify-content: space-between;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    gap: 0;\n    row-gap: 0;\n    width: 100%;;\n\n    // Hide content (text/arrow) on mobile - only show icon\n    @media screen and (max-width: 992px) {\n      display: none !important;\n    }\n\n    @media screen and (max-width: 576px) {\n      font-size: 0.875rem;\n    }\n\n    &__icon {\n      transition: .3s;\n      transform: rotate(-180deg);\n    }\n\n    &::before, &::after {\n      display: none;\n    }\n\n    &__title {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      flex: 1;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
